import useTranslate from '@root/core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card } from 'antd';
import DetailProduct from '../components/detail-inventory/DetailProduct';

const breadcrumbList = [
  {
    tittle: 'Inventory',
    url: ''
  },
  {
    tittle: 'Detailed Inventory',
    url: '/admin/inventory-details'
  }
];

const InventoryDetail = () => {
  const [t] = useTranslate();

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />

      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <DetailProduct />
        </Card>
      </div>
    </>
  );
};

export default InventoryDetail;
